<div class="container-fluid">
  @if (!currentJob) {
    <div class="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="loading-container">
                <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
                <div class="text">Loading...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!!currentJob) {
    <div class="row" style="margin: 0px" [@fadeInOut]>
      <div class="col-md-12" style="padding: 0px">
        <div class="card" id="slice-settings" style="margin-bottom: 0px">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 total-costs">
                @if (!!currentJob) {
                  <div class="cost-details row">
                    <div class="col-md-6">
                      <div>
                        <div class="des-box blue">
                          <div class="des-icon">
                            <img src="/assets/icons/costs/icon02.png" alt="" />
                          </div>
                          <div class="des-detail">
                            <h2>Iterations</h2>
                            <p>{{ iteration }} / {{ currentJob.iterations }}</p>
                          </div>
                        </div>
                        <div style="text-align: right; padding-right: 40px">
                          Job Type: {{ currentJob.type.toLocaleUpperCase() || "" }}
                      <span style="
                          height: 10px;
                          width: 10px;
                          border-radius: 5px;
                          display: inline-block;
                          background-color: blue;
                        " [style.backgroundColor]="
                          currentJob.type == 'QC'
                            ? 'oklch(90.5% 0.182 98.111)'
                            : currentJob.type == 'SC'
                            ? 'oklch(58.6% 0.253 17.585)'
                            : currentJob.type == 'standard'
                            ? '#2196F3'
                            : currentJob.type == 'RWI' 
                            ? 'oklch(75% 0.183 55.934)'
                            : 'oklch(69.6% 0.17 162.48)'
                        "></span>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div id="slice-settings" class="col-md-12">
                <h4 class="card-title">Slice Settings</h4>
                <div class="row">
                  <div class="col-md-6" style="padding: 0">
                    <div class="sliders form-horizontal">
                      @if (!currentJob.modelGrid.is2d) {
                        <div>
                          <div class="form-group" style="display: flex; align-items: center">
                            <div class="col-xs-12 pink-slider">
                              <app-slider label="Inline" [debouncedEmission]="true" [antd]="true" [min]="1"
                                [max]="this.currentJob.modelGrid.nx1" [step]="steps[0]" [(value)]="inlineNumber"
                                (valueChange)="onSliderChanged()">
                              </app-slider>
                            </div>
                          </div>
                          <div class="form-group" style="display: flex; align-items: center">
                            <div class="col-xs-12 pink-slider">
                              <app-slider label="Crossline" [debouncedEmission]="true" [antd]="true" [min]="1"
                                [max]="this.currentJob.modelGrid.nx2" [step]="steps[1]" [(value)]="crosslineNumber"
                                (valueChange)="onSliderChanged()">
                              </app-slider>
                            </div>
                          </div>
                          <div class="form-group" style="display: flex; align-items: center">
                            <div class="col-xs-12 pink-slider">
                              <app-slider label="Depth Slice" [debouncedEmission]="true" [antd]="true" [min]="1"
                                [max]="this.currentJob.modelGrid.nx3" [step]="steps[2]" [(value)]="depthSlice"
                                (valueChange)="onSliderChanged()">
                              </app-slider>
                            </div>
                          </div>
                        </div>
                      }
                      <div class="form-group iteration-slider" style="display: flex; align-items: center">
                        <div class="col-xs-12">
                          <app-slider label="Iteration" [antd]="true" [min]="0" [max]="currentJob.iterations"
                            [completed]="currentJob.iterationsComplete" [(value)]="iteration" [step]="steps[3]"
                            (valueChange)="onVpBockUpdateChange(); onSliderChanged(); clearModelInfo();">
                          </app-slider>
                        </div>
                      </div>
                      @if (
                        timeSliceModels.includes(currentModelTypeId) &&
                        availTimeSlices.length > 0
                        ) {
                        <div class="form-group iteration-slider">
                          <label class="col-sm-2">Time Slice</label>
                          <app-slider class="col-sm-10" [min]="availTimeSlices[0]"
                            [max]="availTimeSlices[availTimeSlices.length - 1]" [(value)]="timeSlice"
                          [step]="getTimeSliceInterval()" (valueChange)="onSliderChanged()"></app-slider>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-md-6 functional-sequence-table">
                    @if (currentJob.type === 'QC') {
                      <div style="color: #AAA; font-size: medium; font-weight: bold; text-align: center; margin-top: 50px;">
                        QC jobs do not have applicable functional sequences. If this is not a QC job, please verify that the naming
                        convention has been followed.
                      </div>
                    } @else {
                      <nz-table #functionalsTable nzSize="middle" id="functionals-table" class="styled-table" style="height: 340px"
                        [nzData]="functional_sequence$ | async" [nzScroll]="{ y: '300px' }" [nzFrontPagination]="false"
                        [nzShowPagination]="false">
                        <thead>
                          <tr>
                            <th nzWidth="60px">Block</th>
                            <th>Functional</th>
                            <th nzWidth="90px">Frequency</th>
                            <th>Iterations</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (data of functionalsTable.data; track data) {
                          <tr [ngStyle]="{
                            opacity: data.block_started ? 1 : 0.5
                          }">
                          <td [ngClass]="data.functional + ' block'" [ngStyle]="{
                              'border-left-width': 15,
                              'border-left-color':
                                FUNCTIONAL_COLORS[data.functional],
                              opacity: data.block_started ? 1 : 0.5
                            }">
                                {{ data["block"] }}
                              </td>
                              <td>{{ data["functional"] }}
                                @if(data['functional'] == 'AWI'){
                                <b class="additionals-tag">
                                  {{data['additionals']}}
                                </b>
                                }
                              </td>
                              <td>{{ data["frequency"]?.toFixed(2) ?? "None" }}</td>
                              <td>
                                {{data["iterations"]}}
                                @if(data['functional'] == 'RWI'){
                                <b class="additionals-tag">
                                  {{data['additionals']}}
                                </b>
                                }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </nz-table>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-to-button-group">
        <button (click)="scrollToAnchor('slice_id_0')" nz-button class="">Scroll to Inline Slice</button>
        @if (fullWidthILXL && slices.length > 1) {
          <button (click)="scrollToAnchor('slice_id_1')" nz-button
          class="">Scroll to Crossline Slice</button>
        }
        @if (showDepthSliceGraph) {
          <button (click)="scrollToAnchor('slice_id_2')" nz-button class="">Scroll
          to Depth Slice</button>
        }
      </div>
      <div class="slices col-xs-12">
        @if (isLoading) {
          <div class="loader">
            <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
          </div>
        }
        <div id="slices">
          <div [ngClass]="{ 'fade-out': isLoading }" class="chart-slice-container"
            style="display: flex; gap: 10px; flex-wrap: wrap">
            @for (slice of slices; track trackBySliceId(i, slice); let i = $index) {
              @if (!currentJob.modelGrid.is2d || i == 0) {
<div [id]="'slice_id_' + i" class="chart-slice card" [style.width]="
                currentJob.modelGrid.is2d && !isMobile
                  ? '75%'
                  : getWidthForSliceType(slice.sliceType)
              " [style.order]="i + 1" [style.height]="
                i == 2 ? depthHeight + 80 + 'px' : height + 80 + 'px'
              " [style.padding]="'10px'" [style.position]="'relative'">
              <h4 class="card-title" style="
                  margin-bottom: 0;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                ">
                    {{ getTitleForSliceType(slice.sliceType) }}&emsp;&emsp;{{
                    getWellName(selectedSonicId)
                    }}
                <div [ngStyle]="{
                    visibility:
                      currentModelTypeId === 'Total_Vp_Update' && i == 0
                        ? 'visible'
                        : 'hidden'
                  }" class="vpUpdateCheck" style="display: inline-flex; align-items: center">
                      <mat-checkbox class="" [(ngModel)]="vpUpdateBlockCheck"
                        (ngModelChange)="onVpBockUpdateChange(true)">Block
                      </mat-checkbox>
                      <mat-checkbox class="" [(ngModel)]="vpUpdateCheck" (ngModelChange)="onVpUpdateChange($event)">Diff
                      </mat-checkbox>
                      <nz-input-group class="legacy-input-styling" nz-size="small" style="width: 100px">
                        <label>Iter</label>
                        <input nz-input type="number" noScrollNumber placeholder="iter" [(ngModel)]="vpDiffIteration"
                          (keyup)="vpUpdateBlockCheck = false; onKeySubmission($event)" />
                      </nz-input-group>
                    </div>
                  </h4>
                  @if (i != 1) {
<div class="actions" style="margin: 0" style="
                  position: absolute;
                  right: 30px;
                  z-index: 2;
                  top: 55px;
                  margin: 0;
                ">
                      <a class="actions__item" [matMenuTriggerFor]="menu" style="padding: 5px"><i
                      class="zmdi zmdi-more-vert"></i></a>
                      <mat-menu #menu="matMenu">
                        @if (i != 1 && modelTypes && modelTypes.length > 0) {
                          <button mat-menu-item
                            [matMenuTriggerFor]="modelTypeMenu">
                            Model Property
                          </button>
                        }
                        @if (i == 0) {
                          <div class="slider-container" style="text-overflow: clip; height: fit-content"
                            [matTooltip]="height">
                            Height
                            <mat-slider [min]="250" [max]="800" [step]="25" (click)="$event.stopPropagation()" #ngSlider>
                              <input matSliderThumb [(ngModel)]="height" (change)="inputHeight = height; setVpHeight()"
                                #ngSliderThumb="matSliderThumb" />
                            </mat-slider>
                          </div>
                        }
                        @if (i == 2) {
                          <div class="slider-container" style="text-overflow: clip" [matTooltip]="depthHeight">
                            Height
                            <mat-slider [min]="200" [max]="maxDepth * 1.3" [step]="25" (click)="$event.stopPropagation()"
                              #ngSlider>
                              <input matSliderThumb [(ngModel)]="depthHeight"
                                (change)="inputDepthHeight = depthHeight; setVpHeight()" #ngSliderThumb="matSliderThumb" />
                            </mat-slider>
                          </div>
                        }
                        <button mat-menu-item (click)="showMinMaxDialog(slice.sliceType)">
                          Min/Max
                        </button>
                        @if (
                          i == 2 && shotOverlayTypes && shotOverlayTypes.length > 0
                          ) {
                          <div mat-menu-item [matMenuTriggerFor]="shotOverlayMenu">
                            <mat-slide-toggle [(ngModel)]="showShotOverlay" (click)="$event.stopPropagation()">
                            </mat-slide-toggle>
                            <span>Shot Overlay&nbsp;</span>
                          </div>
                        }
                        @if (
                          i == 2 &&
                          shotOverlayTypes &&
                          shotOverlayTypes.length > 0 &&
                          showShotOverlay
                          ) {
                          <div class="slider-container">
                            <span>Shot Radius</span>
                            <mat-slider [min]="1" [max]="10" [step]="1" (click)="$event.stopPropagation()">
                              <input [(ngModel)]="shotRadius" matSliderThumb />
                            </mat-slider>
                          </div>
                        }
                        @if (
                          i == 2 &&
                          shotOverlayTypes &&
                          shotOverlayTypes.length > 0 &&
                          showShotOverlay
                          ) {
                          <mat-form-field style="padding-left: 5%">
                            <mat-label>Shot Colour Min</mat-label>
                            <input matInput type="number" noScrollNumber [(ngModel)]="currentShotOverlayType.min"
                              (click)="$event.stopPropagation()" (keyup)="onKeySubmissionShotOverlayType($event)" />
                          </mat-form-field>
                        }
                        @if (
                          i == 2 &&
                          shotOverlayTypes &&
                          shotOverlayTypes.length > 0 &&
                          showShotOverlay
                          ) {
                          <mat-form-field style="padding-left: 5%">
                            <mat-label>Shot Colour Max</mat-label>
                            <input matInput type="number" noScrollNumber [(ngModel)]="currentShotOverlayType.max"
                              (click)="$event.stopPropagation()" (keyup)="onKeySubmissionShotOverlayType($event)" />
                          </mat-form-field>
                        }
                        @if (currentJob.containsLog && i == 0) {
                          <div mat-menu-item [matMenuTriggerFor]="logMenu">
                            <mat-slide-toggle [(ngModel)]="showSonicLog" (change)="onSonicLogClicked()"></mat-slide-toggle>
                            <span>Sonic Logs&nbsp;</span>
                          </div>
                        }
                        <!-- index signifies slice type. 0 == inline, 1 == crossline, 2 == depth -->
                        @if (!showSonicLog && currentJob.containsLog && i == 2) {
                          <div mat-menu-item>
                            <mat-slide-toggle [(ngModel)]="showWellLog" (ngModelChange)="onShowWellLog()"></mat-slide-toggle>
                            <span>Well Logs</span>
                          </div>
                        }
                        @if (
                          i == 0 &&
                          (horizonTypes.length > 0 || project_horizons.length > 0)
                          ) {
                          <div mat-menu-item [matMenuTriggerFor]="horizonMenu">
                            <mat-slide-toggle [(ngModel)]="showHorizon" (click)="onSonicLogClicked()"></mat-slide-toggle>
                            <span>Horizon&nbsp;</span>
                          </div>
                        }
                        @if (!!palettes && palettes.length > 0 && i == 0) {
                          <button mat-menu-item
                            [matMenuTriggerFor]="paletteMenu">
                            Colour Map
                          </button>
                        }
                        @if (timeSliceModels.includes(currentModelTypeId)) {
                          <button mat-menu-item
                            [matMenuTriggerFor]="timeSliceMenu">
                            Time Slices
                          </button>
                        }
                        @if (shotModels.includes(currentModelTypeId)) {
                          <button mat-menu-item [matMenuTriggerFor]="shotMenu">
                            Shots
                          </button>
                        }
                        @if (currentJob.modelGrid.is2d) {
                          <div mat-menu-item>
                            <mat-slide-toggle [(ngModel)]="enableClick">Enable Click</mat-slide-toggle>
                          </div>
                        }
                        @if (
                          !this.currentJob.modelGrid.is2d &&
                          currentModelTypeId != 'One-Way Traveltime'
                          ) {
                          <div mat-menu-item>
                            <mat-slide-toggle (change)="toggleDepthSlice($event)" (click)="$event.stopPropagation()"
                              [checked]="showDepthSliceGraph">
                              Show Depth slice
                            </mat-slide-toggle>
                          </div>
                        }
                        <div mat-menu-item [matMenuTriggerFor]="screenshotConfigMenu" (click)="downloadSlicesAsPng()">
                          Screenshot
                        </div>
                        <div mat-menu-item>
                          <mat-slide-toggle [(ngModel)]="showDottedLines"
                          (click)="$event.stopPropagation(); onSonicLogClicked()"></mat-slide-toggle>
                          <span>Dotted Lines&nbsp;</span>
                        </div>
                        <div mat-menu-item>
                          <mat-slide-toggle [(ngModel)]="smoothingEnabled"
                          (click)="$event.stopPropagation(); onSonicLogClicked()"></mat-slide-toggle>
                          <span>Smoothing&nbsp;</span>
                        </div>
                        @if (!currentJob.modelGrid.is2d) {
                          <div mat-menu-item>
                            <mat-slide-toggle [(ngModel)]="fullWidthILXL" (click)="$event.stopPropagation()"
                            (ngModelChange)="onFullWidthILXLChange($event)"></mat-slide-toggle>
                            <span>Full Width IL/XL&nbsp;</span>
                          </div>
                        }
                        @if (i == 0) {
                          <mat-label htmlFor="xlStart"
                          style="padding-left: 16px; font-size: 15px">Start:</mat-label>
                        }
                        <div class="menu-xl-start-fields">
                          @if (
                            currentJob.modelGrid.is2d ||
                            (currentJob.x2_is_inline && i == 0)
                            ) {
                            <nz-input-group [nzSize]="'default'" id="xlStart" style="flex-grow: 1" (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>XL</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLStartCrossline"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                          @if (
                            currentJob.modelGrid.is2d ||
                            (currentJob.x2_is_inline && i == 0)
                            ) {
                            <nz-input-group [nzSize]="'default'" style="flex-grow: 1" (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>IL</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLStartInline"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                          @if (
                            !currentJob.modelGrid.is2d &&
                            !currentJob.x2_is_inline &&
                            i == 0
                            ) {
                            <nz-input-group [nzSize]="'default'" id="xlStart" style="flex-grow: 1" (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>IL</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLStartInline"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                          @if (
                            !currentJob.modelGrid.is2d &&
                            !currentJob.x2_is_inline &&
                            i == 0
                            ) {
                            <nz-input-group [nzSize]="'default'" style="flex-grow: 1" (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>XL</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLStartCrossline"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                          @if (i == 0) {
                            <nz-input-group [nzSize]="'default'" style="flex-grow: 1"
                              (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>Depth</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLStartDepth"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                        </div>
                        @if (i == 0) {
                          <mat-label htmlFor="xlEnd" style="padding-left: 16px; font-size: 15px">End:</mat-label>
                        }
                        <div class="menu-xl-end-fields">
                          @if (
                            currentJob.modelGrid.is2d ||
                            (currentJob.x2_is_inline && i == 0)
                            ) {
                            <nz-input-group [nzSize]="'default'" id="xlEnd" style="flex-grow: 1" (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>XL</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLEndCrossline"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                          @if (
                            currentJob.modelGrid.is2d ||
                            (currentJob.x2_is_inline && i == 0)
                            ) {
                            <nz-input-group [nzSize]="'default'" style="flex-grow: 1" (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>IL</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLEndInline"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                          @if (
                            !currentJob.modelGrid.is2d &&
                            !currentJob.x2_is_inline &&
                            i == 0
                            ) {
                            <nz-input-group [nzSize]="'default'" id="xlEnd" style="flex-grow: 1" (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>IL</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLEndInline"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                          @if (
                            !currentJob.modelGrid.is2d &&
                            !currentJob.x2_is_inline &&
                            i == 0
                            ) {
                            <nz-input-group [nzSize]="'default'" style="flex-grow: 1" (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>XL</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLEndCrossline"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                          @if (i == 0) {
                            <nz-input-group [nzSize]="'default'" style="flex-grow: 1"
                              (click)="$event.stopPropagation()" [style.width.px]="70">
                              <label>Depth</label>
                              <input nz-input type="number" noScrollNumber [(ngModel)]="ILXLEndDepth"
                                (keyup)="submitSliceRanges($event)" />
                            </nz-input-group>
                          }
                        </div>
                        <div style="display: flex; justify-content: flex-end">
                          <button mat-stroked-button (click)="resetRanges()" style="margin: 5px 16px">
                            Reset Ranges
                          </button>
                        </div>
                      </mat-menu>
                      <mat-menu #screenshotConfigMenu="matMenu">
                        <div mat-menu-item>
                          <mat-slide-toggle [(ngModel)]="screenshotWithVertProfile" (click)="$event.stopPropagation()">
                            With Vertical Profile
                          </mat-slide-toggle>
                        </div>
                        @if (!this.currentJob.modelGrid.is2d) {
                          <div mat-menu-item>
                            <mat-slide-toggle (change)="toggleDepthSlice($event)" [checked]="showDepthSliceGraph"
                              (click)="$event.stopPropagation()">
                              With depth Slice
                            </mat-slide-toggle>
                          </div>
                        }
                      </mat-menu>
                      <mat-menu #modelTypeMenu="matMenu">
                        @for (modelType of modelTypes; track modelType) {
                          <button mat-menu-item (click)="setModelType(modelType, $event)">
                            <span>{{ modelType.name }}</span>
                            @if (modelType.id === currentModelTypeId) {
                              <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                            }
                          </button>
                        }
                      </mat-menu>
                      <mat-menu #paletteMenu="matMenu">
                        @for (palette of palettes; track palette) {
                          <button mat-menu-item (click)="setPalette(palette)">
                            <span>{{ palette }}</span>
                            @if (palette == currentJob.last_used_palette) {
                              <i class="zmdi zmdi-check"
                              style="margin-left: 2px"></i>
                            }
                          </button>
                        }
                      </mat-menu>
                      <mat-menu #logMenu="matMenu">
                        @for (log of currentJob.wellLogs; track log) {
                          <button mat-menu-item (click)="setLog(log.id)">
                            <span>{{ log.name }} : IL - {{ log.inline }}, XL -
                            {{ log.crossline }}</span>
                          </button>
                        }
                      </mat-menu>
                      <mat-menu #horizonMenu="matMenu">
                        @if (project_horizons.length > 0) {
                          <nz-divider style="margin: 5px" nzText="Project Horizons"
                          ></nz-divider>
                        }
                        @for (type of project_horizons; track type) {
                          <div mat-menu-item (click)="setProjectHorizon(type.id)">
                            <span>{{ type.name }}</span>
                            @if (isProjectHorizonSelected(type.id)) {
                              <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                            }
                          </div>
                        }
                        @if (horizonTypes.length > 0) {
                          <nz-divider style="margin: 5px" nzText="Job Horizons"></nz-divider>
                        }
                        @for (type of horizonTypes; track type) {
                          <div mat-menu-item (click)="setHorizon(type)">
                            <span>{{ type }}</span>
                            @if (isHorizonSelected(type)) {
                              <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                            }
                          </div>
                        }
                      </mat-menu>
                      <mat-menu #shotOverlayMenu="matMenu">
                        @for (shotOverlayType of shotOverlayTypes; track shotOverlayType) {
                          <button mat-menu-item
                            (click)="setShotOverlayType(shotOverlayType)">
                            <span>{{ shotOverlayType.name }}</span>
                            @if (shotOverlayType.id === currentShotOverlayType.id) {
                              <i class="zmdi zmdi-check"
                              style="margin-left: 2px"></i>
                            }
                          </button>
                        }
                      </mat-menu>
                      <mat-menu #timeSliceMenu="matMenu">
                        @for (time of availTimeSlices; track time) {
                          <button mat-menu-item (click)="setTimeSlice(time)">
                            <span>{{ time }}</span>
                            @if (timeSlice == time) {
                              <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                            }
                          </button>
                        }
                      </mat-menu>
                      <mat-menu #shotMenu="matMenu">
                        @for (shot of availShots; track shot) {
                          <button mat-menu-item (click)="setShot(shot)">
                            <span>{{ shot }}</span>
                            @if (shotId == shot) {
                              <i class="zmdi zmdi-check" style="margin-left: 2px"></i>
                            }
                          </button>
                        }
                      </mat-menu>
                    </div>
                  }
                  <app-chart-slice [shot]="shotId" [id]="currentJob.id" [ranges]="i_sliceRanges[slice.sliceType]"
                    [xSteps]="getXStepForSliceType(slice.sliceType)" [ySteps]="getYStepForSliceType(slice.sliceType)"
                    [sliceType]="getAdjustedSliceType(slice.sliceType)" [iteration]="iteration"
                    [sliceNumber]="getNumberForSliceType(slice.sliceType)" [xTitle]="getXTitleForSliceType(slice.sliceType)"
                    [yTitle]="getYTitleForSliceType(slice.sliceType)" [reloadChartData]="reloadChartData"
                    [relayoutChart]="relayoutChart" [height]="i == 2 ? depthHeight : height"
                    [is2d]="currentJob.modelGrid.is2d" [xLine]="getXForSliceType(slice.sliceType)"
                    [yLine]="getYForSliceType(slice.sliceType)" [showLegend]="i != 1 || inlineWidth == 100"
                    [palette]="currentJob.last_used_palette" [sonicLogId]="sonicLogId"
                    [depthSliceWellLog]="depthSliceWellLogs" [dx]="this.currentJob.modelGrid.dx"
                    [sonicNX]="getSonicNXForSliceType(slice.sliceType)"
                    [sonicWidth]="getSonicWidthForSliceType(slice.sliceType)"
                    [hoverLabelX]="getHoverLabelX(slice.sliceType)" [hoverLabelY]="getHoverLabelY(slice.sliceType)"
                    [velocityRange]="i_sliceVelocityRanges[slice.sliceType]" [modelType]="currentModelTypeId"
                    [shotOverlayType]="currentShotOverlayType" [showShotOverlay]="getShotOverlay(slice.sliceType)"
                    [shotRadius]="shotRadius" [showHorizons]="getHorizons(slice.sliceType)"
                    [showProjectHorizons]="getProjectHorizons(slice.sliceType)" [horizonColors]="horizonColors"
                    [projectHorizonColors]="projectHorizonColors" [totalIterations]="currentJob.iterations"
                    [x2IsInline]="currentJob.x2_is_inline" [isVpReference]="vpUpdateCheck"
                    [vpIteration]="vpUpdateBlockCheck ? getVpBlock() : vpDiffIteration" [timeSlice]="timeSlice"
                [pngNameDetails]="{
                  pName: currentJob.projectName,
                  jName: currentJob.name,
                  cpnum: iteration
                }" [indexInDocument]="
                  vpPositionSwapped ? (i == 1 ? 2 : i == 2 ? 1 : 0) : i
                " [showDottedLines]="showDottedLines" [smoothingEnabled]="smoothingEnabled"
                    [startDepth]="ILXLStartDepth" [endDepth]="ILXLEndDepth" [startInline]="ILXLStartInline"
                    [endInline]="ILXLEndInline" [startCrossline]="ILXLStartCrossline" [endCrossline]="ILXLEndCrossline"
                    (clickEmitter)="onClickEmit($event)" (colorbarTextEmitter)="onColorbarTextEmit($event)"
                    (loadFinishedEmitter)="onLoadFinishedEmit($event)"
                    (sliceDataEmitter)="slice.sliceType === 1 || slice.sliceType === 2 ? onSliceDataReceived($event) : null">
                  </app-chart-slice>
                <!-- </div> -->
              </div>
            }
          }
          @if (!isLoading) {
<div id="velocity-profile" [ngClass]="
              currentJob.modelGrid.is2d
                ? 'velocity-profile'
                : 'velocity-profile'
            " [style.width]="getWidthForSliceType(null)"
              style="margin-left: 0 !important; order: 4">
            <div class="card" [style.paddingBottom]="
                currentJob.modelGrid.is2d ? '7.15px' : '12.15px'
              ">
              <h4 class="card-title" style="
                  white-space: nowrap;
                  margin-bottom: 0;
                  height: 52px;
                  line-height: 52px;
                  position: relative;
                  z-index: 5;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                ">
                  Vertical Profile
                  @if (!currentJob.modelGrid.is2d) {
                    <mat-slide-toggle class="swap-pos" [(ngModel)]="vpPositionSwapped"
                      (ngModelChange)="swapPosition()">
                      <span>View next to Inline</span>
                    </mat-slide-toggle>
                  }
                </h4>
              <app-vertical-profile [height]="
                  currentJob.modelGrid.is2d
                    ? vpHeight + 4
                    : this.vpPositionSwapped
                    ? vpHeight
                    : depthHeight
                " [depth]="depth" [depthSlice]="depthSlice" [velocities]="velocities" [hideAxes]="false"
                  [axisMin]="verticalProfileAxis[0]" [axisMax]="verticalProfileAxis[1]" [modelTypeId]="currentModelTypeId"
                  [isLoading]="verticalProfileIsLoading" [hasError]="verticalProfileHasError"
                  [gridSpacing]="currentJob.modelGrid.dx" [ILXLStartDepth]="ILXLStartDepth" [ILXLEndDepth]="ILXLEndDepth"
                  [sonicLogId]="sonicLogId" (axisMinMaxEmitter)="onVerticalProfileAxisMinMaxUpdate($event)"
                (syncAxisEmitter)="onSyncAxisUpdate($event)"></app-vertical-profile>
              </div>
            </div>
          }
          @if (!isLoading) {
            <div id="comment" style="flex: 1 1 300px; max-width: 350px; order: 4">
              <div class="card" style="padding-bottom: 2.15px !important">
                <h4 class="card-title" style="white-space: nowrap; margin-bottom: 0">
                  Comment
                </h4>
                <div style="padding-top: 20px">
                  <textarea [(ngModel)]="comments" matTooltip="Enter your comment" rows="3"
                  style="width: 100%; resize: vertical"></textarea>
                </div>
                <button class="custom-button" (click)="updateComment()" [disabled]="isUpdated">
                  {{ isUpdated ? "Updated" : "Save" }}
                </button>
              </div>
            </div>
          }
          <div class="card" id="_model_information_container" style="height: fit-content; width: 400px; order: 5">
            <nz-spin [nzSpinning]="this.modelInfoLoading">
              <div style="
                  margin-bottom: 10px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                ">
                <h4 class="card-title" style="margin: 0">Model information</h4>
                <div>
                  @if (!this.modelInfoFetched) {
                    <button nz-button (click)="getModelInformation()">
                      Get Model Information
                    </button>
                  }
                  @if (this.modelInfoFetched) {
                    <button nz-button nzType="default" (click)="clearModelInfo()">
                      <span nz-icon nzType="close" nzTheme="outline"></span>
                    </button>
                  }
                </div>
              </div>
              <div id="_model_information" class="pretty-parsed-data"></div>
            </nz-spin>
          </div>
          @if (showHorizon) {
<div style="
              display: inline-block;
              vertical-align: top;
              height: fit-content;
              order: 4;
            " [style.height]="vpHeight" class="card">
              <h4 class="card-title" style="margin-bottom: 15px">
                Selected Horizons:
              </h4>
              @for (h of showProjectHorizonTypes; track h; let i = $index) {
                <div>
                  <div style="display: inline-block">
                    {{ getProjectHorizonName(h) }}
                  </div>
              <Button style="
                  display: inline-block;
                  width: 16px;
                  height: 16px;
                  border-radius: 8px;
                " [(colorPicker)]="projectHorizonColors[i]" (colorPickerChange)="onColorChanged($event)"
                  [style.background-color]="projectHorizonColors[i]">
                </Button>
              </div>
            }
            @for (type of showHorizonTypes; track type; let i = $index) {
              <div>
                <div style="display: inline-block">{{ type }}</div>
              <Button style="
                  display: inline-block;
                  width: 16px;
                  height: 16px;
                  border-radius: 8px;
                " [(colorPicker)]="horizonColors[i]" (colorPickerChange)="onColorChanged($event)"
                [style.background-color]="horizonColors[i]">
              </Button>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div id="screenshot-container-div"></div>
</div>
<div class="sliders-bar" [ngClass]="{ open: sliderBarOpen, visible: sliderBarVisible }">
  <div class="col-md-12">
    <div>
      <h4 class="card-title" style="margin: 0">Slice Settings</h4>
      <div class="actions" (click)="sliderBarOpen = !sliderBarOpen">
        <i class="fa fa-arrow-up"></i>
      </div>
    </div>
    <div class="row">
      @if (!currentJob.modelGrid.is2d) {
        <div class="col-md-6" style="padding: 0">
          @if (!currentJob.modelGrid.is2d) {
            <div>
              <div class="form-group">
                <div class="col-xs-12">
                  <app-slider label="Inline" [debouncedEmission]="true" [antd]="true" [min]="1"
                    [max]="this.currentJob.modelGrid.nx1" [step]="steps[0]" [(value)]="inlineNumber"
                    (valueChange)="onSliderChanged()">
                  </app-slider>
                </div>
              </div>
              <div class="form-group">
                <div class="col-xs-12">
                  <app-slider label="Crossline" [debouncedEmission]="true" [antd]="true" [min]="1"
                    [max]="this.currentJob.modelGrid.nx2" [step]="steps[1]" [(value)]="crosslineNumber"
                    (valueChange)="onSliderChanged()">
                  </app-slider>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <div class="col-md-6" style="padding: 0; white-space: nowrap">
        <div>
          @if (!currentJob.modelGrid.is2d) {
            <div class="form-group">
              <div class="col-xs-12">
                <app-slider label="Depth Slice" [debouncedEmission]="true" [antd]="true" [min]="1"
                  [max]="this.currentJob.modelGrid.nx3" [step]="steps[2]" [(value)]="depthSlice"
                  (valueChange)="onSliderChanged()">
                </app-slider>
              </div>
            </div>
          }
          <div class="form-group">
            <div class="col-xs-12">
              <app-slider label="Iteration" [antd]="true" [min]="0" [max]="currentJob.iterations"
                [completed]="currentJob.iterationsComplete" [(value)]="iteration" [step]="steps[3]"
                (valueChange)="onVpBockUpdateChange(); onSliderChanged(); clearModelInfo();">
              </app-slider>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <mat-checkbox style="margin-top: 10px; margin-right: 38px; float: right" [(ngModel)]="synchroniseSettings"
        (ngModelChange)="onSynchroniseChange($event)">Synchronise Settings</mat-checkbox>
      </div>
    </div>
  </div>
</div>
</div>
}
</div>


<ng-template #notificationTemplate>
  <div style="display: flex;">
    <div style="width: 50px;">
      <span nz-icon nzType="info-circle" nzTheme="outline" style="color: #1e90ff; font-size: 25px;"></span>
    </div>
    <div>
      <h5> New iterations available</h5>
      <div>
        There are new iterations available for this job!
        <br>
          Would you like to reparse?
        </div>
        <button nz-button style="float: right; margin-top: 10px;" nzType="primary" (click)="reparseJob()"
          [nzLoading]="reparsingJob" [disabled]="reparsingJob">
          {{ reparsingJob ? 'Reparsing...' : 'Reparse Job' }}
        </button>
      </div>
    </div>
  </ng-template>